/**
 * Funciones de formateo
 */

/**
 * Formatear fecha a formato local
 */
export const formatearFecha = (fecha) => {
  if (!fecha) return '-';
  const date = new Date(fecha);
  return date.toLocaleDateString('es-MX', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
};

/**
 * Formatear fecha con hora
 */
export const formatearFechaHora = (fecha) => {
  if (!fecha) return '-';
  const date = new Date(fecha);
  return date.toLocaleString('es-MX', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
};

/**
 * Formatear moneda
 */
export const formatearMoneda = (monto) => {
  if (monto === null || monto === undefined) return '$0.00';
  return new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
  }).format(monto);
};

/**
 * Formatear un monto en bolívares con formato venezolano: punto para
 * miles, coma para decimales (ej. 121.193,94). Los montos en Bs vienen
 * de PostgreSQL como texto/numeric y se mostraban crudos (ej.
 * "121193.9382"), sin agrupar miles y con hasta 4 decimales.
 */
export const formatearBolivares = (monto) => {
  if (monto === null || monto === undefined || monto === '') return 'Bs. 0,00';
  const valor = typeof monto === 'string' ? parseFloat(monto) : monto;
  if (Number.isNaN(valor)) return 'Bs. 0,00';
  return 'Bs. ' + new Intl.NumberFormat('es-VE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(valor);
};

/**
 * Formatear número
 */
export const formatearNumero = (numero) => {
  if (numero === null || numero === undefined) return '0';
  return new Intl.NumberFormat('es-MX').format(numero);
};

/**
 * Formatear porcentaje
 */
export const formatearPorcentaje = (valor) => {
  if (valor === null || valor === undefined) return '0%';
  return `${valor.toFixed(2)}%`;
};

/**
 * Truncar texto
 */
export const truncarTexto = (texto, longitud = 50) => {
  if (!texto) return '';
  if (texto.length <= longitud) return texto;
  return `${texto.substring(0, longitud)}...`;
};

/**
 * Capitalizar primera letra
 */
export const capitalize = (texto) => {
  if (!texto) return '';
  return texto.charAt(0).toUpperCase() + texto.slice(1).toLowerCase();
};

/**
 * Formatear teléfono
 */
export const formatearTelefono = (telefono) => {
  if (!telefono) return '';
  const cleaned = ('' + telefono).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3];
  }
  return telefono;
};
